import { c as _c } from "react/compiler-runtime";
import { MailingId } from 'modules/mailing/types/mailing-interface';
import { useControlledSwr } from '@systemeio/util';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
interface AttachmentsPolicyInterface {
  willBeSentAsLinks: boolean;
}
export const useAttachmentsPolicy = mailingId => {
  const $ = _c(2);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return useControlledSwr(`/api/dashboard/customer/mailing/${mailingId}/attachment-policy`, fetcher, t1, !!user && !!mailingId);
};